//#region IMPORTS

import React, { Component } from 'react';
import * as DKFDS from "dkfds";
import URL from '../../Constants/URL.js'
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { formatAddress } from '../../components/HelperComponents/AddressFormatter'
import { GetStatusName, GetStatusVm } from '../../components/HelperComponents/StatusHelper';
import { GetCprStatusName, GetCprStatusKode, IsCprStatusValidForNonDriverCards } from '../../components/HelperComponents/CprStatusHelper';
import { formatAuthorizationNumber, isCardStatusValidForRenewal, nameTooLong, sortCardTableByDate, getEkspeditionsType, localDateToUtcDate } from '../../components/HelperComponents/Helpers';
import { checkIfCardExpired, checkIfCardExpiresWitihinTwoMonths } from '../../components/HelperComponents/ValidityDateHelpers';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { WorkshopCardVm } from '../../Models/WorkshopCardVm';
import { BusinessVm } from '../../Models/BusinessVm';
import { PersonVm } from '../../Models/PersonVm';
import { filterCardStatusesRenewed, filterCardStatusesReplaced } from '../../components/HelperComponents/FilterCardStatuses.js';
import { ValidationType } from '../../Constants/ValidationTypes.ts';
import { DateFormatter } from '../../components/HelperComponents/DateFormatter.ts'
import { CardOrderWorkshopCard } from '../../Models/CardOrderWorkshopCard'
import { CprToDateOfBirth } from '../../components/HelperComponents/CprToDateOfBirth.ts'

//#endregion

//#region CLASS/CONSTRUCTOR/STATE

export default function Create() {
  return <CreateClass />
}

class CreateClass extends Component {
  static displayName = Create.name;

  orderTypes = {
    foerstegangsudstedelse: "Førstegangsudstedelse",
    nyudstedelse: "Nyudstedelse",
    fornyelse: "Fornyelse",
    erstatning: "Erstatning",
    udskiftning: "Udskiftning"
  }

  amountOfCards = 1;

  constructor(props) {
    super(props);
    this.toast = React.createRef();

    this.state = {

      // search input
      cprInput: "",
      cvrInput: "",
      // other input
      authorizationNumberInput: "",
      responsibleHolderInput: "",
      firstNameOnCard: "",
      lastNameOnCard: "",
      workshopNameOnCard: "",

      //Button press
      cvrSearchButtonPressed: false,
      cprSearchButtonPressed: false,
      orderButtonPressed: false,

      //Validation
      cvrNumberIsValid: false,
      cprNumberIsValid: false,
      responsibleHolderIsValid: false,
      authorizationNumberIsValid: false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,
      workshopNameOnCardIsValid: false,

      businessVm: new BusinessVm(),
      personVm: new PersonVm(),

      openModal: false,
      openDispensationsModal: false,
      dispensationIsOk: null,
      showSpinner: false,
      showSpinner2: false,

      // order info input
      orderType: this.orderTypes.foerstegangsudstedelse,
      validTo: new Date(),
      validFrom: new Date(),
      previousCardType: "",
      previousCardStatus: "",
      expressDelivery: false,

      workshopCards: [],
      selectedCard: new WorkshopCardVm(),
      newestCardNotValidYet: false,
    }

  }

  componentDidMount() {
    this.setValidityPeriod()
    DKFDS.init();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.orderType !== this.state.orderType || prevState.selectedCard !== this.state.selectedCard) {
      if (prevState.selectedCard !== this.state.selectedCard) {
        this.setState({ orderType: this.getRadiobuttons()[0] }, () =>
          this.setValidityPeriod())
      }
      else {
        this.setValidityPeriod()
      }
    }
    if (prevState.personVm !== this.state.personVm) {
      this.setNameOnCard(this.state.personVm)
    }
    if (prevState.businessVm !== this.state.businessVm) {
      this.setWorkshopNameOnCard(this.state.businessVm)
    }
  }

  //#endregion

  //#region API CALLS

  searchCpr() {
    this.setState({ cprSearchButtonPressed: true })
    if (this.state.cprNumberIsValid) {
      this.clearOnCprSearch()
      if (!this.state.cvrSearchButtonPressed || !this.state.cvrNumberIsValid) {
        this.toast.current.show("Værksted Mangler", "Søg på et gyldigt værksted inden du søger på en mekaniker.", "warning")
        return
      }
      if (!this.state.authorizationNumberIsValid) {
        this.toast.current.show("Autorisationsnummer Mangler", "Indtast et autorisationsnummer inden du søger på en mekaniker.", "warning")
        return
      }
      this.setState({ showSpinner2: true })
      this.fetchPerson()
      this.fetchWorkshopcards()
    }
  }

  CreateCard() {
    var model = new CardOrderWorkshopCard()

    model.KortEjerNavn = this.state.workshopNameOnCard;
    model.KortEjerAdresse = this.state.businessVm.Address.StreetNameAndNumber;
    model.MekanikerAdresse = this.state.personVm.Address.StreetNameAndNumber;
    model.MekanikerPostNr = this.state.personVm.Address.PostalCode;
    model.MekanikerBy = this.state.personVm.Address.City;
    model.CvrNr = this.state.businessVm.Cvr;
    model.AutorisationsNr = this.state.authorizationNumberInput;
    model.KortType = "W";
    model.OrdreType = this.state.expressDelivery ? "1" : "0";
    model.UdstedelsesDato = new Date();
    model.SendTilEkspeditionssted = false;
    model.GebyrFrit = false;
    model.EkspeditionsType = getEkspeditionsType(this.state.orderType);
    model.KortBrugerFornavn = this.state.firstNameOnCard;
    model.KortBrugerEfternavn = this.state.lastNameOnCard;
    model.FoedselsDato = CprToDateOfBirth(this.state.personVm.Cpr);
    model.PostAdresseNavn = this.state.workshopNameOnCard;
    model.PostAdresseVejOgNr = this.state.businessVm.Address.StreetNameAndNumber;
    model.PostAdresseStedNavn = this.state.businessVm.Address.PlaceName;
    model.PostAdressePostNr = this.state.businessVm.Address.PostalCode;
    model.PostAdressePostDistrikt = this.state.businessVm.Address.City;


    model.GyldighedStartDato = localDateToUtcDate(this.state.validFrom);
    model.UdloebsDato = localDateToUtcDate(this.state.validTo);

    if (!this.isCardNyOrForstegang()) {
      model.KortNrTidligereKort = this.state.selectedCard.CardNumber;
    }
    model.AnsvarligIndehaver = this.state.responsibleHolderInput;
    model.UdstedendeMyndighed = "2001";
    model.PersonNr = this.state.personVm.Cpr;
    model.Antal = this.amountOfCards.toString();
    model.Malfunctioning = false;
    model.IsAndenGeneration = "true";
    fetch(URL + "/api/WorkshopCard/createOrder/", {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(model)
    })
      .then(response => response.json())
      .then((result) => {
        if (result.valid) {
          if (!this.isCardNyOrForstegang()) { this.setStatusOfPreviousCard() }
          this.clearPage()
          this.showSuccessToast()
          this.setState({ openModal: false })
        }
        else if (result.errors.length > 0) {
          this.showWorkshopCardErrorToast(result.errors[0].exception, result.errors[0].message)
        }
        else
          this.showWorkshopCardErrorToast("error", "")
      })
      .catch(error => console.error(error));
  }

  isCardNyOrForstegang() {
    var orderType = this.state.orderType
    return orderType === this.orderTypes.foerstegangsudstedelse || orderType === this.orderTypes.nyudstedelse
  }

  setStatusOfPreviousCard() {
    let model = Object.assign({}, this.state.selectedCard);
    model.Status = GetStatusVm(this.state.previousCardStatus)

    let success = true;

    let requestInfo = {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(model)
    }

    fetch(URL + "/api/workshopcard/ChangeCardStatus", requestInfo)
      .then(response => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false
        }
      })
      .catch(() => success = false)
      .finally(
        () => {
          if (!success) this.toast.current.show("Fejl", `Status på tidligere kort (${model.CardNumber}) blev ikke opdateret.`, "error")
        }
      )

  }

  fetchWorkshopcards() {
    fetchModel("GET", URL + "/api/WorkshopCard/GetWorkshopCardsByCprCvrAutNr", `?cpr=${this.state.cprInput}&cvr=${this.state.businessVm.Cvr}&authorizationNumber=${this.state.authorizationNumberInput}`, WorkshopCardVm)
      .then(model => {
        this.handleWorkshopSearchResults(model)
      })
      .catch(error => {
        this.showWorkshopCardErrorToast(error, "et værkstedskort")
      })
      .finally(() => this.setState({ showSpinner2: false }))
  }

  fetchPerson() {
    fetchModel("GET", URL + "/api/search/GetPerson", this.state.cprInput, PersonVm)
      .then(model => {
        if (model[0].Cpr && model[0].Cpr.length === 10) {
          this.setState({ personVm: model[0] },
            () => this.handleCprStatus())
        }
        else this.showCPRErrorToast("No result", "en person") // tager højde for at der kan sendes et tomt resultat. 
      })
      .catch(error => this.showCPRErrorToast(error, "en person"))
  }

  fetchBusinessVm() {
    this.setState({ cvrSearchButtonPressed: true })
    this.clearOnCvrSearch()
    if (this.state.cvrNumberIsValid) {
      this.setState({ showSpinner: true })
      fetchModel("GET", URL + "/api/search/GetVirksomhed", this.state.cvrInput, BusinessVm)
        .then(model => {
          if (model[0].Cvr && model[0].Cvr.length === 8) {
            this.setState({ businessVm: model[0] })
          }
          else this.showCVRErrorToast("No result", "et værksted")  // tager højde for at der kan sendes et tomt resultat. 

          this.checkForBusinessCards();
        })
        .catch(error => {
          this.showCVRErrorToast(error, "et værksted");
        })
        .finally(() => this.setState({ showSpinner: false }))
    }
  }

  checkForBusinessCards() {
    this.setState({ showSpinner: true });

    fetch(URL + `/api/BusinessCard/CheckForActiveBusinessCardsByCvr/${this.state.cvrInput}`, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET',
    })
      .then(response => response.json())
      .then((result) => {
        if (result) {
          this.setState({ openDispensationsModal: true, dispensationIsOk: false })
        }
      })
      .catch(error => {
        this.toast.current.show("Fejl i søgning", "Det var ikke muligt at checke om cvr nummeret har et virksomhedskort tilknyttet.", "warning")
        console.error(error)
      });
  }

  //#endregion

  //#region API RESPONSE MAPPING

  handleWorkshopSearchResults(result) {
    result = sortCardTableByDate(result)
    this.setState({
      workshopCards: result,
      newestCardNotValidYet: new Date(result[0].ValidFrom) > new Date(),
    }, () => {
      this.setState({ orderType: this.getRadiobuttons()[0] })
    })
  }

  handleCprStatus() {
    if (!IsCprStatusValidForNonDriverCards(this.state.personVm.CprStatus)) {
      this.toast.current.show("CPR Status", `Personer med status ${GetCprStatusKode(this.state.personVm.CprStatus)} kan ikke bestille kort.`, "warning")
    }
  }

  //#endregion

  //#region GUI EVENTS HANDLING

  setValidityPeriod() {
    let newValidFrom = null
    let newValidTo = null
    switch (this.state.orderType) {
      case this.orderTypes.foerstegangsudstedelse:
      case this.orderTypes.nyudstedelse:
        newValidFrom = new Date()
        newValidTo = new Date()
        newValidTo.setFullYear(newValidTo.getFullYear() + 1)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      case this.orderTypes.fornyelse:
        if (checkIfCardExpired(this.state.selectedCard)) {
          newValidFrom = new Date()
        } else {
          newValidFrom = new Date(this.state.selectedCard.ValidTo)
          newValidFrom.setDate(newValidFrom.getDate() + 1)
        }
        newValidTo = new Date(newValidFrom)
        newValidTo.setFullYear(newValidFrom.getFullYear() + 1)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      case this.orderTypes.erstatning:
        newValidFrom = new Date(Math.max(new Date(), new Date(this.state.selectedCard.ValidFrom)))
        newValidTo = new Date(this.state.selectedCard.ValidTo)
        break;
      case this.orderTypes.udskiftning:
        newValidFrom = new Date(Math.max(new Date(), new Date(this.state.selectedCard.ValidFrom)))
        newValidTo = new Date()
        newValidTo.setFullYear(newValidTo.getFullYear() + 1)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      default:
    }

    this.setState({ validFrom: newValidFrom, validTo: newValidTo })
  }


  getRadiobuttons() {
    if (this.state.workshopCards.length > 0 && this.state.selectedCard) {
      if (!this.state.newestCardNotValidYet) {
        if (checkIfCardExpired(this.state.selectedCard)) {
          return [this.orderTypes.fornyelse]
        }
        else if (checkIfCardExpiresWitihinTwoMonths(this.state.selectedCard)) {
          return [this.orderTypes.fornyelse, this.orderTypes.erstatning, this.orderTypes.udskiftning]
        }
      }
      return [this.orderTypes.erstatning, this.orderTypes.udskiftning]
    }
    return [this.orderTypes.foerstegangsudstedelse]
  }

  getSelectedCard(cardNumber) {
    return this.state.workshopCards.find(card => card.CardNumber === cardNumber)
  }

  onRowSelected(row) {
    let card = row ? this.getSelectedCard(row[0]) : null
    this.setState({ selectedCard: card }, () => {
      this.setState({ orderType: this.getRadiobuttons()[0] },
        () => this.setValidityPeriod()
      )
    })
  }

  isAuthorizationNumberValid() {
    let checkOk = this.state.authorizationNumberIsValid
    if (!this.isCardNyOrForstegang()) {
      let autNrsMatch = this.state.authorizationNumberInput === this.state.selectedCard.AuthorizationNumber.trim()
      if (!autNrsMatch)
        this.toast.current.show("Autorisationsnummer", "Autorisationsnummerfeltet må ikke afvige fra det forrige kort.", "warning")
      checkOk = checkOk && autNrsMatch
    }
    return checkOk
  }

  isMechanicInfoValid() {
    let checkOk = this.state.personVm.Cpr
      && this.state.personVm.FirstName
      && this.state.personVm.LastName
      && this.state.personVm.Address.StreetNameAndNumber
      && IsCprStatusValidForNonDriverCards(this.state.personVm.CprStatus)
    return checkOk
  }

  isWorkshopInfoValid() {
    let businessVm = this.state.businessVm
    let checkOk = businessVm.Cvr
      && businessVm.Name
      && businessVm.Address.StreetNameAndNumber
    return checkOk
  }

  isPreviousCardStatusValid() {
    var ordertypesWithStatusChange = [this.orderTypes.erstatning, this.orderTypes.fornyelse, this.orderTypes.udskiftning]
    if (ordertypesWithStatusChange.includes(this.state.orderType)) {
      return this.state.previousCardStatus.length > 0
    }
    return true
  }

  validateOrder() {
    this.setState({ orderButtonPressed: true })

    let orderIsValid = true;

    let errorMessage = [];
    if (this.state.newestCardNotValidYet) {
      if (!this.state.selectedCard) {
        this.toast.current.show("Se bestilling", "Man må ikke lave en førstegangsudstedelser når der er eksisterende kort.", "error")
        orderIsValid = false;
      }
    }
    if (this.state.dispensationIsOk === false) { /// explicit check because null means no disp is needed.
      this.toast.current.show("Fejl i CVR", "Cvr nummeret har et virksomhedskort tilknyttet og dispensation er ikke godkendt, søg på cvr igen for at godkende dispensation..", "error")
      orderIsValid = false;
    }
    if (!this.isWorkshopInfoValid()) {
      errorMessage.push("værkstedsinformation")
      orderIsValid = false;
    }
    if (!this.state.responsibleHolderIsValid) {
      errorMessage.push("ansvarlig indehaver")
      orderIsValid = false;
    }
    if (!this.isAuthorizationNumberValid()) {
      errorMessage += "Autorisationsnummer, "
      orderIsValid = false;
    }
    if (!this.isMechanicInfoValid()) {
      errorMessage.push("gyldig mekanikerinformation")
      orderIsValid = false;
    }
    if (!this.isPreviousCardStatusValid()) {
      errorMessage.push("status på tidligere kort")
      orderIsValid = false;
    }
    if (nameTooLong(this.state.personVm.FirstName) && !this.state.firstNameOnCardIsValid) {
      errorMessage.push("fornavn på kort")
      orderIsValid = false;
    }
    if (nameTooLong(this.state.personVm.LastName) && !this.state.lastNameOnCardIsValid) {
      errorMessage.push("efternavn på kort")
      orderIsValid = false;
    }
    if (nameTooLong(this.state.businessVm.Name) && !this.state.workshopNameOnCardIsValid) {
      errorMessage.push("værkstedsnavn på kort")
      orderIsValid = false;
    }

    if (orderIsValid) {
      this.setState({ openModal: true })
    } else {
      this.showValidationErrorToast(errorMessage)
    }
  }

  showValidationErrorToast(errorMessage) {
    errorMessage[0] = errorMessage[0].charAt(0).toUpperCase() + errorMessage[0].slice(1);
    var errorString = errorMessage.reduce(function (p, d, i) {
      return p + (i === errorMessage.length - 1 ? ' og ' : ', ') + d;
    });
    errorString += " mangler."
    this.toast.current.show("Se bestilling", errorString, "error")
  }

  clearPage() {
    this.setState({
      // search input
      cprInput: "",
      cvrInput: "",
      // other input
      authorizationNumberInput: "",
      responsibleHolderInput: "",
      firstNameOnCard: "",
      lastNameOnCard: "",
      workshopNameOnCard: "",

      //Button press
      cvrSearchButtonPressed: false,
      cprSearchButtonPressed: false,
      orderButtonPressed: false,

      //Validation
      cvrNumberIsValid: false,
      cprNumberIsValid: false,
      responsibleHolderIsValid: false,
      authorizationNumberIsValid: false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,
      workshopNameOnCardIsValid: false,

      businessVm: new BusinessVm(),
      personVm: new PersonVm(),

      openModal: false,
      openDispensationsModal: false,
      dispensationIsOk: null,
      showSpinner: false,
      showSpinner2: false,

      // order info input
      orderType: this.orderTypes.foerstegangsudstedelse,

      previousCardType: "",
      previousCardStatus: "",
      expressDelivery: false,

      workshopCards: [],
      selectedCard: null,
      newestCardNotValidYet: false
    })
  }

  clearOnCvrSearch() {
    this.setState({
      // search input
      cprInput: "",
      //cvrInput: "",
      // other input
      authorizationNumberInput: "",
      responsibleHolderInput: "",
      firstNameOnCard: "",
      lastNameOnCard: "",
      workshopNameOnCard: "",

      //Button press
      //cvrSearchButtonPressed: false,
      cprSearchButtonPressed: false,
      orderButtonPressed: false,

      //Validation
      //cvrNumberIsValid: false,
      cprNumberIsValid: false,
      responsibleHolderIsValid: false,
      authorizationNumberIsValid: false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,
      workshopNameOnCardIsValid: false,

      businessVm: new BusinessVm(),
      personVm: new PersonVm(),

      openModal: false,
      openDispensationsModal: false,
      dispensationIsOk: null,
      //showSpinner: false,
      showSpinner2: false,

      // order info input
      orderType: this.orderTypes.foerstegangsudstedelse,

      previousCardType: "",
      previousCardStatus: "",
      expressDelivery: false,

      workshopCards: [],
      selectedCard: null,
      newestCardNotValidYet: false,
    })
  }

  clearOnCprSearch() {
    this.setState({
      // search input
      //cprInput: "",
      //cvrInput: "",
      // other input
      //authorizationNumberInput: "",
      //responsibleHolderInput: "",
      firstNameOnCard: "",
      lastNameOnCard: "",
      //workshopNameOnCard: "",

      //Button press
      //cvrSearchButtonPressed: false,
      //cprSearchButtonPressed: false,
      //orderButtonPressed: false,

      //Validation
      //cvrNumberIsValid: false,
      //cprNumberIsValid: false,
      //responsibleHolderIsValid: false,
      //authorizationNumberIsValid: false,
      firstNameOnCardIsValid: false,
      lastNameOnCardIsValid: false,
      //workshopNameOnCardIsValid: false,

      //businessVm: new BusinessVm(),
      personVm: new PersonVm(),

      openModal: false,
      openDispensationsModal: false,
      //dispensationIsOk: null,
      //showSpinner: false,
      //showSpinner2: false,

      // order info input
      orderType: this.orderTypes.foerstegangsudstedelse,
      previousCardType: "",
      previousCardStatus: "",
      expressDelivery: false,

      workshopCards: [],
      selectedCard: null,
      newestCardNotValidYet: false,
    })
  }

  showSuccessToast() {
    this.toast.current.show("Success", "Din bestilling er oprettet. ", "success")
  }

  showCVRErrorToast(error, message) {
    this.setState({ showSpinner: false })
    if (error === "No result") {
      this.toast.current.show("Værksted", "Der findes ikke " + message + " på det søgte CVR nummer", "warning")
    }
    else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else {
      this.toast.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  showCPRErrorToast(error, message) {
    this.setState({ showSpinner2: false })
    if (error === "No result") {
      this.toast.current.show("Værkstedskort", "Der findes ikke " + message + " på det søgte CPR nummer", "warning")
    }
    else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else {
      this.toast.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }
  showWorkshopCardErrorToast(error, message) {
    this.setState({ showSpinner2: false })
    if (error === "No result") {
      return;
    }
    else if (error === "Failed response") {
      this.toast.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else if (message.length > 0) {
      this.toast.current.show("Fejl", message, "error")
    }
    else {
      this.toast.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  showCprStatusWarning() {
    return this.state.orderButtonPressed
      && !IsCprStatusValidForNonDriverCards(this.state.personVm.CprStatus)
  }

  setNameOnCard(person) {
    this.setState({ firstNameOnCard: person.FirstName, lastNameOnCard: person.LastName })
  }

  setWorkshopNameOnCard(workshop) {
    this.setState({ workshopNameOnCard: workshop.Name })
  }

  checkCardValidForRenewal(card) {
    return isCardStatusValidForRenewal(card.Status.Id)
  }

  checkboxDisabled(i) {
    // if newest card is not active yet, it is possible to toggle between, the two top cards
    // otherwise, only the top card is selected, amnd the selection cannot be changed
    if (this.state.newestCardNotValidYet) {
      return !((i === 0 || i === 1) && this.state.workshopCards.length > 1)
    }
    return true
  }

  //#endregion

  //#region GUI/RENDER

  render() {
    return (
      <div>
        <Fstyr.Toast ref={this.toast} />
        <Fstyr.Modal
          show={this.state.openModal}
          onDecline={() => { this.setState({ openModal: false }) }}
          onAccept={() => { this.CreateCard() }}
          label="Bestil værkstedskort"
          buttonGroupLabel="Bestil værkstedskort"
          buttonAcceptLabel="Bestil"
          buttonDeclineLabel="Annullér"
          layout={[
            {
              "label": "Værkstedsinformationer",
              "inputs": [
                { "label": "CVR", "value": this.state.businessVm.Cvr },
                { "label": "Værkstedsnavn", "value": this.state.workshopNameOnCard },
                { "label": "CVR adresse", "value": formatAddress(this.state.businessVm.Address, true) },
                { "label": "Autorisations​nummer", "value": this.state.authorizationNumberInput }
              ]
            },
            {
              "label": "Mekanikerinformationer",
              "inputs": [
                { "label": "CPR", "value": this.state.personVm.Cpr },
                { "label": "Fornavn", "value": this.state.firstNameOnCard },
                { "label": "Efternavn", "value": this.state.lastNameOnCard },
                { "label": "Adresse", "value": formatAddress(this.state.personVm.Address, false) }
              ]
            },
            {
              "label": "Bestillingsinformationer",
              "inputs": [
                { "label": "Type", "value": this.state.orderType },
                { "label": "Gyldighedsperiode", "value": DateFormatter(this.state.validFrom) + " til " + DateFormatter(this.state.validTo) },
                { "label": "Ekspreslevering", "value": this.state.expressDelivery ? "Ja" : "Nej" },
              ]
            }
          ]}
        />

        <Fstyr.Modal
          show={this.state.openDispensationsModal}
          onDecline={() => this.clearPage()}
          onAccept={() => { this.setState({ openDispensationsModal: false, dispensationIsOk: true }) }}
          label="Advarsel!"
          buttonAcceptLabel="Godkend"
          buttonDeclineLabel="Annullér"
          layout={[
            {
              "inputs": [
                { "label": "Virksomhedskort fundet", "value": "Der skal foreligge dispensation" },

              ]
            }
          ]}
        />

        <Fstyr.Segment
          title="Opret Værkstedskort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage() }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Angiv CVR"
        >
          <Fstyr.Input
            value={this.state.cvrInput}
            direction='col'
            label="CVR nummer"
            onChange={(value) => this.setState({ cvrInput: value })}
            validation={true}
            type={"number"}
            validationType={ValidationType.cvr}
            errorBodyText={"Skal være 8 cifre langt"}
            errorExampleText={"F.eks. 12345678"}
            onEnterPressed={() => this.fetchBusinessVm()}
            setValid={(valid) => this.setState({ cvrNumberIsValid: valid })}
            buttonClicked={this.state.cvrSearchButtonPressed || this.state.orderButtonPressed}
            onValidatingButtonPressed={() => this.setState({ cvrSearchButtonPressed: true })}
          />
          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.fetchBusinessVm()
              }}
              disabled={this.state.showSpinner}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Værkstedsinformation"
        >
          <div className="fstyr-attention-box">
            <p className="fstyr-header-info">Værkstedsoplysninger</p>
            <Fstyr.Input
              value={this.state.businessVm.Cvr}
              label="CVR"
              direction="row"
              readonly={true}
            />
            <Fstyr.Input
              value={this.state.businessVm.Name}
              label="Værkstedsnavn"
              direction="row"
              readonly={true}
            />
            <Fstyr.Input
              value={formatAddress(this.state.businessVm.Address, true)}
              label="CVR adresse"
              direction="row"
              readonly={true}
            />
            <Fstyr.Input
              value={this.state.responsibleHolderInput}
              direction='row'
              label="Ansvarlig indehaver"
              onChange={(value) => this.setState({ responsibleHolderInput: value })}
              validation={true}
              validationType={ValidationType.textWithSpacesMax35}
              errorBodyText={"Skal være bogstaver med eller uden mellemrum. Maks 35 tegn."}
              errorExampleText={"F.eks. Jens Jensen"}
              onEnterPressed={() => { }}
              setValid={(valid) => this.setState({ responsibleHolderIsValid: valid })}
              buttonClicked={this.state.orderButtonPressed}
              onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
            />
            <Fstyr.Input
              value={this.state.authorizationNumberInput}
              label="Autorisations&#8203;nummer"
              direction="row"
              onChange={(value) => this.setState({ authorizationNumberInput: value })}
              validation={true}
              type={"text"}
              validationType={ValidationType.autorisationsNr}
              errorBodyText={"Skal være 3 tal, bindestreg og et bogstav."}
              errorExampleText={"F.eks. 123-A"}
              onEnterPressed={() => { }}
              setValid={(valid) => this.setState({ authorizationNumberIsValid: valid })}
              buttonClicked={this.state.orderButtonPressed || this.state.cprSearchButtonPressed}
              onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
            />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Angiv CPR"
        >
          <Fstyr.Input
            value={this.state.cprInput}
            label="CPR nummer"
            direction={"col"}
            onChange={(value) => { this.setState({ cprInput: value }) }}
            validation={true}
            validationType={ValidationType.cpr}
            errorBodyText={"Forkert format (10 tal)"}
            errorExampleText={"f.eks. 1234567890"}
            onEnterPressed={() => this.searchCpr()}
            setValid={(valid) => this.setState({ cprNumberIsValid: valid })}
            buttonClicked={this.state.cprSearchButtonPressed || this.state.orderButtonPressed}
            onValidatingButtonPressed={() => this.setState({ cprSearchButtonPressed: true })}
          />
          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => this.searchCpr()}
              disabled={this.state.showSpinner2}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner
              show={this.state.showSpinner2}
            />
          </div>

          <div className="fstyr-attention-box">
            <p className="fstyr-header-info">Mekanikerinformation</p>
            <Fstyr.Input
              value={this.state.personVm.Cpr}
              label="CPR"
              direction="row"
              readonly={true}
            />
            <div className={this.showCprStatusWarning() ? "form-group form-error" : ""}>
              <Fstyr.Input
                label="Status"
                readonly={true}
                value={GetCprStatusName(this.state.personVm.CprStatus)}
                direction="row"
              />
              {this.showCprStatusWarning() && (
                <span className="form-error-message" id="form-error-error">
                  {`For at bestille et førerkort må status ikke være ${GetCprStatusKode(this.state.personVm.CprStatus)}`}
                </span>
              )}
            </div>
            <Fstyr.Input
              value={this.state.personVm.FirstName}
              label="Fornavn"
              direction="row"
              readonly={true}
            />
            <Fstyr.Input
              value={this.state.personVm.LastName}
              label="Efternavn"
              direction="row"
              readonly={true}
            />
            <Fstyr.Input
              value={formatAddress(this.state.personVm.Address, false)}
              label="Adresse"
              direction="row"
              readonly={true}
            />
          </div>

          <Fstyr.SelectableTable
            label="Registreret værkstedskort"
            headers={["Kortnr.", "CVR", "Autorisationsnummer", "Fornavn", "Efternavn", "Startdato", "Udløbsdato", "Status"]}
            data={this.state.workshopCards === [] ? null : this.state.workshopCards.map(function (card) {
              return [
                card.CardNumber,
                card.Cvr,
                formatAuthorizationNumber(card.AuthorizationNumber),
                card.Person.FirstName,
                card.Person.LastName,
                DateFormatter(card.ValidFrom),
                DateFormatter(card.ValidTo),
                GetStatusName(card.Status.Id)
              ]
            })}
            note={"Virksomhed har " + this.state.workshopCards.length + " registreringer på værkstedskort"}
            path={"workshopCard"}
            tableName="danishResultsTable"
            preSelect={true}
            onRowSelected={(row) => this.onRowSelected(row)}
            useCustomDisableCheckboxFunction={true}
            disableCheckbox={(index) => this.checkboxDisabled(index)}
            useLinks={true}
          />
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Bestilling"
        >
          {
            this.state.dispensationIsOk &&
            <span className="badge badge-small badge-warning" style={{ marginBottom: "15px", textTransform: "inherit" }}>Dispensation er godkendt af sagsbehandler.</span>
          }
          <div>
            <Fstyr.RadioButtonGroup
              label="Angiv type af bestilling"
              choices={this.getRadiobuttons()}
              value={this.state.orderType}
              onClick={(value) => this.setState({ orderType: value })}
            />
            {/*Status på tidligere kort*/}
            <div className={(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) ? "form-group form-error" : ""}>

              {(this.state.orderType === this.orderTypes.fornyelse || this.state.orderType === this.orderTypes.udskiftning) &&
                <div>
                  <Fstyr.Dropdown
                    items={filterCardStatusesRenewed(require('../../assets/CardStatus.json'))}
                    width={320}
                    onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                    label="Status på tidligere kort"
                    direction="row"
                  />
                </div>
              }
              {
                (this.state.orderType === this.orderTypes.erstatning) &&
                <div>
                  <Fstyr.Dropdown
                    items={filterCardStatusesReplaced(require('../../assets/CardStatus.json'))}
                    width={320}
                    onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                    label="Status på tidligere kort"
                    direction="col"
                  />
                </div>
              }

              {(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) && (
                <span className="form-error-message" id="form-error-error">
                  {"Status skal udfyldes"}
                </span>
              )}
            </div>

            <p className="fstyr-text-header">Leveringsinformation</p>
            <Fstyr.Checkbox
              label="Ekspreslevering"
              checked={this.state.expressDelivery}
              onClick={(value) => this.setState({ expressDelivery: value })}
            />

            {nameTooLong(this.state.businessVm.Name) &&
              <Fstyr.Input
                value={this.state.workshopNameOnCard}
                direction='column'
                label="Fornavn på kort"
                onChange={(value) => this.setState({ workshopNameOnCard: value })}
                validation={true}
                validationType={ValidationType.textWithSpacesMax35}
                setValid={(valid) => this.setState({ workshopNameOnCardIsValid: valid })}
                buttonClicked={true} // hardcoded to ensure validation always active
                onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                errorBodyText={"Værkstedets navn er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn. Husk at virksomhedstype (ApS, A/S, ...) skal bevares."}
                errorExampleText={"f.eks. Transportselskabet Konstantino. ApS"}
              />}

            {nameTooLong(this.state.personVm.FirstName) &&
              <Fstyr.Input
                value={this.state.firstNameOnCard}
                direction='column'
                label="Fornavn på kort"
                onChange={(value) => this.setState({ firstNameOnCard: value })}
                validation={true}
                validationType={ValidationType.textWithSpacesMax35}
                setValid={(valid) => this.setState({ firstNameOnCardIsValid: valid })}
                buttonClicked={true} // hardcoded to ensure validation always active
                onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                errorBodyText={"Personens fornavn er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn."}
                errorExampleText={"f.eks. Anna B. C."}
              />}
            {nameTooLong(this.state.personVm.LastName) &&
              <Fstyr.Input
                value={this.state.lastNameOnCard}
                direction='column'
                label="Efternavn på kort"
                onChange={(value) => this.setState({ lastNameOnCard: value })}
                validation={true}
                validationType={ValidationType.textWithSpacesMax35}
                setValid={(valid) => this.setState({ lastNameOnCardIsValid: valid })}
                buttonClicked={true} // hardcoded to ensure validation always active
                onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
                errorBodyText={"Personens efternavn er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn."}
                errorExampleText={"f.eks. A. B. Carlsen"}
              />}
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Bestillingsinformation"
        >
          <Fstyr.Button
            label="Se bestilling"
            onClick={() => {
              this.validateOrder()
            }}
          />
        </Fstyr.Segment>
        <Fstyr.Segment
          title=""
          isPageTitle={true}
        />
      </div>

    );
  }
}
//#endregion
